import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const SocialMedia = (props: LevelProps) => {
  return (
    <LevelPage
      {...props}
      heading="Which platform do you want to create content for?"
      cardSize="small"
      cards={LEVEL_CARDS.L2.SOCIAL_MEDIA}
    />
  )
}
